import { apolloClient } from 'App';

import { GetUserQuery, ToggleUserNotificationPreferenceFromAdminMutation } from 'data/__generated__';
import { GET_USER_QUERY } from 'data/queries/user';

export function notificationPreferencesUpdatedHandler({
    notificationPreferences,
    userId,
}: {
    notificationPreferences: ToggleUserNotificationPreferenceFromAdminMutation['toggleUserNotificationPreferenceFromAdmin'];
    userId: string;
}) {
    const result = apolloClient.readQuery<GetUserQuery>({ query: GET_USER_QUERY, variables: { userId } });
    if (!result) {
        return;
    }
    const { userFromAdmin } = result;

    const data = {
        userFromAdmin: {
            ...userFromAdmin,
            notificationPreferences,
        },
    };

    apolloClient.writeQuery({
        query: GET_USER_QUERY,
        data,
    });
}
